import React from 'react'

import Navigation from './../../landing/components/Nav'
import PrivacyComponent from './../../landing/components/Privacy'
import Footer from './../../landing/components/Footer'


const Privacy = props => {
	return (
		<>
			<Navigation />
			<PrivacyComponent />
			<Footer />
		</>
	)
}

export default Privacy